import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get SolarBrand
export const getSolarBrand = createAsyncThunk("/getlist-solar-brand", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-solar-brand`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        return response;
    } catch (error) {
        console.error('Error fetching panel- ', error);
        throw error;
    }
})


